import {useCallback, useEffect, useState} from 'react';

const UNINTENTIONAL_SCROLL_OFFSET = 50;

const useIsPageScrolled = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  const handler = useCallback(() => {
    if (window.scrollY < UNINTENTIONAL_SCROLL_OFFSET) {
      setIsScrolled(false);
      return;
    }

    setIsScrolled(true);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handler);

    return () => window.removeEventListener('scroll', handler);
  }, [handler]);

  return isScrolled;
};

export default useIsPageScrolled;
